import React from 'react';

import { IconButton } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLessRounded';

export const ArrowDown = ({ onClick }: { onClick?: any }) => (
  <IconButton className="arrow-expand-less" onClick={onClick}>
    <ExpandLess color="primary" />
  </IconButton>
);
